import { injectIntl } from 'react-intl';
import Title from './Title';

export default injectIntl(Title);
